import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /reklamationen. Liste lebt in reklamationen.index.tsx,
 * Detail in reklamationen.$id.tsx, Neuanlage in reklamationen.neu.tsx
 * (Phase 5 Stufe I, Slice 4).
 */
export const Route = createFileRoute('/reklamationen')({
  component: ReklamationenLayout,
});

function ReklamationenLayout(): JSX.Element {
  return <Outlet />;
}
